import './index.scss';

import React from 'react';
import { lang } from '@umu/ukit-lang';
import { setEnterpriseInviteStatus } from '../../../../../services/setEnterpriseInviteStatus';
import UmuLogo from '../../images/logo.png'

interface IProps {
    closeDialog(): void;
    data: any;
}

interface EnterpriseInfoType {
    id: string;
    enterprise_id: string;
    [key: string]:any;
}

export class InviteCUserDialog extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    confirmInvitation = (enterpriseInfo: EnterpriseInfoType, status: number) => {
        const { id, enterprise_id } = enterpriseInfo;
        const params = {
            id,
            enterprise_id,
            invite_status: status,
        };
        setEnterpriseInviteStatus(params);
    };

    /**
     * 0 : 待确认
     * 1 : 确认
     * 2 : 拒绝
     */

    onClose = () => {
        this.confirmInvitation(this.props.data, 0);
        this.props.closeDialog();
    };
    onCancel = () => {
        this.confirmInvitation(this.props.data, 2);
        this.props.closeDialog();
    };
    onConfirm = () => {
        this.confirmInvitation(this.props.data, 1);
        this.props.closeDialog();
    };

    render() {
        const data = this.props.data;
        const { enterprise_name,enterprise_logo} = data;

        const title = lang('邀请你加入 {$0} 企业版',enterprise_name);
        const p1 = lang(
            '如果你选择加入 ${enterprise}，你的账户将更新为企业账户，你可以享有 ${enterprise} 企业版的权限，并可以和 ${enterprise} 企业版学习平台上的其他用户协同工作，共享数据。',
        ).replace(/\$\{enterprise\}/g, enterprise_name);
        const p2 = lang(
            '同时，你的账户权限将由 ${enterprise} 企业版学习平台的管理员统一分配，你在UMU平台上所有创建的课程将归属 ${enterprise} 所有。',
        ).replace(/\$\{enterprise\}/g, enterprise_name);

        return (
            <div className="show-invite-c-user-dialog-wrap">
                <div className="title">{title}</div>
                <div className="show-invite-c-user-dialog-content">
                <div className="enterprise">
                    <img src={enterprise_logo||UmuLogo} alt={enterprise_name} className="left" />
                    <div className="right">{enterprise_name}</div>
                </div>
                    <div>
                        <p>{p1}</p>
                        <p>{p2}</p>
                        <p>
                            {lang(
                                '在点击“确认“之前，你的账户仍属于个人所有。如有任何问题，发送邮件至support@umu.com联络UMU。',
                            )}
                        </p>
                    </div>
                </div>
                <div className="operation">
                    <span className="btn btn-optional cancel" onClick={this.onCancel}>
                        {lang('拒绝')}
                    </span>
                    <span className="btn btn-optional confirm" onClick={this.onConfirm}>
                        {lang('确认加入')}
                    </span>
                </div>
                <i className="icon iconfont icon-close" onClick={this.onClose}></i>
            </div>
        );
    }
}
